import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = ({ config }) => {
  const navigate = useNavigate();
  
  const navigateToRSVP = () => {
    navigate('/rsvp');
  };

  return (
    <section 
      className="hero" 
      style={{
        '--hero-mobile': `url(${config.design.images.heroMobile})`,
        '--hero-desktop': `url(${config.design.images.heroDesktop})`,
        '--hero-mobile-position': config.design.images.heroMobilePosition || 'center top',
        '--hero-text-position': config.design.images.heroTextPosition || '75%',
        '--hero-bg-color': config.design.colors.headerFooterColour,
        color: config.design.colors.primary
      }}
    >
      <div className="hero-overlay" style={{ backgroundColor: 'transparent' }}></div>
      <div className="hero-palm-left" style={{ backgroundImage: 'url(/palm.jpg)' }}></div>
      <div className="hero-palm-right" style={{ backgroundImage: 'url(/palm.jpg)' }}></div>
      <div className="hero-content">
        <h1 className="hero-title" style={{ fontFamily: config.design.fonts.heading, color: config.design.colors.primary }}>
          {config.couple.name1} & {config.couple.name2}
        </h1>
        <div className="hero-divider" style={{ backgroundColor: config.design.colors.primary }}></div>
        <p className="hero-subtitle" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.primary }}>
          {config.content.hero.title}
        </p>
        <p className="hero-date" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.primary }}>
          {config.date.ceremony.date}
        </p>
        <button 
          className="hero-cta" 
          onClick={navigateToRSVP}
          style={{ 
            fontFamily: config.design.fonts.body,
            borderColor: config.design.colors.primary,
            color: config.design.colors.primary
          }}
        >
          RSVP
        </button>
      </div>
    </section>
  );
};

export default Hero;

